<app-card [loading]="state === 'locationRequesting' || state === 'loggingIn'">
  <div class="content flex flex-1 column justify-center">
    @switch (state) {
      @case ("locationRequesting") {
        <p>{{ "demo.login.location.requesting" | translate }}</p>
      }
      @case ("locationDenied") {
        <h2>{{ "demo.login.location.denied.headline" | translate }}</h2>
        <p>{{ "demo.login.location.denied.description" | translate }}</p>
        <button
          type="button"
          class="button primary-button mt-2"
          (click)="requestLocation()"
        >
          {{ "demo.login.location.denied.button" | translate }}
        </button>
      }
      @case ("loggingIn") {
        <h2>{{ "demo.login.headline" | translate }}</h2>
        <p>{{ "demo.login.subheadline" | translate }}</p>
      }
      @case ("loginError") {
        <h2>{{ "demo.login.error.headline" | translate }}</h2>
        <p>{{ "demo.login.error.description" | translate }}</p>
        <button
          type="button"
          class="button primary-button mt-2"
          (click)="retryLogin()"
        >
          {{ "demo.login.error.button" | translate }}
        </button>
      }
      @case ("locationError") {
        <h2>{{ "demo.login.locationError.headline" | translate }}</h2>
        <p>{{ "demo.login.locationError.description" | translate }}</p>
        <button
          type="button"
          class="button primary-button mt-2"
          (click)="retryLogin()"
        >
          {{ "demo.login.error.button" | translate }}
        </button>
      }
      @case ("groupExpired") {
        <h2>{{ "demo.login.groupExpired.headline" | translate }}</h2>
        <p>{{ "demo.login.groupExpired.description" | translate }}</p>
      }
      @case ("tooFarAway") {
        <h2>{{ "demo.login.tooFarAway.headline" | translate }}</h2>
        <p>{{ "demo.login.tooFarAway.description" | translate }}</p>
      }
      @case ("inUse") {
        <h2>{{ "demo.login.inUse.headline" | translate }}</h2>
        <p>{{ "demo.login.inUse.description" | translate }}</p>
        <button
          type="button"
          class="button primary-button mt-2"
          (click)="retryLogin()"
        >
          {{ "demo.login.inUse.button" | translate }}
        </button>
      }
    }
  </div>
</app-card>
